import { clipUtils } from './common'

export const clip = {
  /**
   * 设置数据到剪切板
   * @param content 数据
   */
  set(content: string): Promise<true> {
    return new Promise((resolve, reject) => {
      clipUtils.set(content, () => {
        resolve(true)
      }, (msg: string) => {
        reject(msg)
      })
    })
  },
  /**
   * 获取剪切板数据
   */
  get(): Promise<string> {
    return new Promise((resolve, reject) => {
      clipUtils.get((res) => {
        resolve(res)
      }, (msg: string) => {
        reject(msg)
      })
    })
  },
  /**
   * 清空剪切板
   */
  clear(): Promise<true> {
    return new Promise((resolve, reject) => {
      clipUtils.clear(() => {
        resolve(true)
      }, (msg: string) => {
        reject(msg)
      })
    })
  },


} as ClipDSL

